import {
  isMediaCardString,
  keyToMediaCardType,
  type MediaCardType,
} from '@wandb/weave/common/types/media';

import {
  collapseMetricTypes,
  type CollapsibleMetricTypes,
} from '../../MetricSearch/collapseMetricTypes';

/**
 * The card type to draw a metric's media with, or null when the panels would
 * not render it as media at all.
 *
 * Derives from `collapseMetricTypes`, the same rule panel generation uses to
 * decide what a key is, rather than resolving a type here. That is the point: a
 * picker has to offer a key exactly when the panel would render it as media,
 * and two hand-written rules drift.
 */
export function mediaCardTypeForMetric(
  metric: CollapsibleMetricTypes
): MediaCardType | null {
  const type = collapseMetricTypes(metric);
  return type != null && isMediaCardString(type)
    ? keyToMediaCardType(type)
    : null;
}
